module.exports = __webpack_public_path__ + "img/01web-you.0facf0a6.png";